<script setup>
import Toggle from '../Toggle.vue'
import SendSvg from '@svg/new-send.svg'
import NotificationSvg from '@svg/new-notification.svg'
import { nextTick, onMounted, reactive } from 'vue'
import axios from 'axios'
import VueScrollTo from 'vue-scrollto'
import { useTextareaAutosize } from '@vueuse/core'

const { textarea, input } = useTextareaAutosize()

const props = defineProps({
    comment: Object
})

const emit = defineEmits()

const replyForm = reactive({
    body: null,
    subscribe: true
})

const reply = () => {
    axios.post(`/comments/${props.comment.id}/replies`, replyForm).then((response) => {
        props.comment.children.push(response.data)
        replyForm.body = null

        nextTick(() => {
            VueScrollTo.scrollTo(`#comment-${response.data.id}`, { offset: -100, duration: 500 })
            emit('replying', false)
        })
    })
}

onMounted(() => {
    textarea.value.focus()
})
</script>

<template>
    <form v-on:submit.prevent="reply" class="mt-3 lg:mt-8 bg-[rgba(27,32,74,1)] px-8 py-5 rounded-2xl" v-on:click="textarea.focus()">
        <div class="flex items-start flex-wrap">
            <div class="flex-grow w-full md:w-auto">
                <textarea dusk="comment-reply-textarea" ref="textarea" class="border-0 w-full bg-transparent resize-none placeholder:text-[rgba(148,162,209,1)] text-[rgba(148,162,209,1)] text-sm focus:ring-0 p-0 leading-normal mt-2" placeholder="Write your reply here" required v-model="input" v-model.body="replyForm.body"></textarea>
            </div>

            <button dusk="comment-reply-button" :disabled="replyForm.processing" class="mt-1 md:mt-0 px-3 py-2.5 -mr-0.5 rounded-lg leading-none bg-[rgba(107,96,255,1)] text-[rgba(233,232,255,1)] font-medium inline-flex items-center text-sm space-x-1" aria-label="Post comment">
                <SendSvg class="size-5" />
                <span>Reply</span>
            </button>
        </div>
        <div
            class="mt-4 border rounded-lg p-2 border-[rgba(35,40,86,1)] flex items-center"
        >
            <label :for="`subscribe_${comment.id}`" class="flex items-center flex-grow">
                <NotificationSvg class="text-[rgba(112,120,176,1)] size-5 shrink-0" />
                <span class="text-[rgba(112,120,176,1)] text-xs font-medium ml-2 transition-colors leading-tight">Subscribe to reply notifications</span>
            </label>
            <Toggle :id="`subscribe_${comment.id}`" name="subscribe" v-model="replyForm.subscribe" />
        </div>
    </form>
</template>
